export default __webpack_public_path__ + "static/media/YAS0920.34I-42439_-25423_0.b7a73529.jpg";